export default __webpack_public_path__ + "static/media/knight-2.d342bbd5.svg";